import { init } from '@instantdb/react';

const APP_ID = '6b5b1802-f3ec-4c6f-879f-7de22f2c1ce7';

export const db = init({ appId: APP_ID });
